import { SmartLink } from "./SmartLink";

const productScreenshots = [
  {
    eyebrow: "RapidFactory",
    title: "Compliant environment delivery with live infrastructure posture.",
    copy:
      "RapidFactory gives teams a product surface for AWS-first baseline delivery, fleet status, cost visibility, and remediation context.",
    href: "/rapid-factory",
    primaryImageAlt: "RapidFactory dashboard screenshot",
    primaryImageSrc: "/assets/img/home-1.png",
    secondaryImageAlt: "RapidFactory EC2 fleet status screenshot",
    secondaryImageSrc: "/assets/img/status-1.png",
    signals: ["AWS EC2 fleet", "Compliance posture", "Drift-aware operations"]
  },
  {
    eyebrow: "KyberDocs",
    title: "Evidence and compliance workflows operators can actually use.",
    copy:
      "KyberDocs connects control status, findings, evidence, and remediation into an audit-readiness surface for regulated work.",
    href: "/kyber-docs",
    primaryImageAlt: "KyberDocs evidence and compliance dashboard screenshot",
    primaryImageSrc: "/assets/img/compliance-1.png",
    signals: ["Control status", "Evidence workflow", "Audit readiness"]
  }
];

type ProductScreenshotShowcaseProps = {
  className?: string;
  copy?: string;
  eyebrow?: string;
  title?: string;
};

export function ProductScreenshotShowcase({
  className = "",
  copy = "A closer look at the Holocron products customers will use to build environments and prove the work.",
  eyebrow = "Product screenshots",
  title = "See RapidFactory and KyberDocs in motion."
}: ProductScreenshotShowcaseProps) {
  return (
    <section className={`surface-dark product-screenshot-section${className ? ` ${className}` : ""}`}>
      <div className="section-shell product-screenshot-shell">
        <div className="section-heading-row product-screenshot-heading">
          <div>
            <p className="section-kicker">{eyebrow}</p>
            <h2 className="section-title">{title}</h2>
          </div>
          <p className="section-copy">{copy}</p>
        </div>

        <div className="product-screenshot-grid">
          {productScreenshots.map((product) => (
            <article key={product.eyebrow} className="product-screenshot-card">
              <div className="product-screenshot-copy">
                <p className="section-kicker">{product.eyebrow}</p>
                <h3>{product.title}</h3>
                <p>{product.copy}</p>
                <div className="product-screenshot-signals" aria-label={`${product.eyebrow} product signals`}>
                  {product.signals.map((signal) => (
                    <span key={signal}>{signal}</span>
                  ))}
                </div>
                <SmartLink className="inline-link" href={product.href}>
                  Explore {product.eyebrow}
                </SmartLink>
              </div>

              <SmartLink className="product-screenshot-frame" href={product.href} aria-label={`Open ${product.eyebrow}`}>
                <span className="product-screenshot-frame-bar" aria-hidden="true">
                  <i />
                  <i />
                  <i />
                </span>
                <img alt={product.primaryImageAlt} src={product.primaryImageSrc} />
                {product.secondaryImageSrc ? (
                  <span className="product-screenshot-inset" aria-hidden="true">
                    <img alt={product.secondaryImageAlt} src={product.secondaryImageSrc} />
                  </span>
                ) : null}
              </SmartLink>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
